import { useState, useEffect } from "react";
import SirImage from "../Images/Sir.jpeg";
import AOS from "aos";
import "aos/dist/aos.css";

const Features = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const features = [
    {
      title: "Instant Digital Identity",
      description:
        "Promote your business or service without needing an App or Website. Simple QR code creates your complete digital presence.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
          />
        </svg>
      ),
      points: [
        "Share instantly with customers",
        "Has viral effect - Easy to find New Customers",
      ],
    },
    {
      title: "Marketing and Selling is now Simple",
      description:
        "Launch your online presence instantly – ideal for farmers, rural entrepreneurs, small businesses,  retailers, and artisans to sell from home.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          id="el-s5mcw6el"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            id="el-eld3mqsa"
          ></path>
        </svg>
      ),
      points: [
        "Reach thousands of customers in few hours",
        "Simple Catalog management",
        "No Inventory hassles: Real-Time Syncing",
      ],
    },
    {
      title: "Affordable Pricing",
      description:
        "Frugal Cost - as low as Chai-Samosa a day. True value for Money. Made for Common-Man.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          id="el-us7tjqje"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            id="el-bs1s49oj"
          ></path>
        </svg>
      ),
      points: [
        "Pay only for what you need",
        "Pay when you grow",
        "No one can beat our price",
      ],
    },
    {
      title: "Simple Digital Solutions",
      description:
        "Simplicity is the key to our solutions. Farmers, Rural entrepreneurs, less Tech-savvy users can easily use our QR based solutions and start their digital journey.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          id="el-5api3zb5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            id="el-sptnb71y"
          ></path>
        </svg>
      ),
      points: [
        "Simple QR Based solution",
        "Easy to learn and use",
        "Simplicity at it's best",
      ],
    },

    {
      title: "Direct Connect with Customers",
      description:
        "Build direct relationships with your customers without middlemen or complicated platforms.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M7 8h10M7 12h6m-3 8a9 9 0 100-18 9 9 0 000 18zm5-3l4 4"
          />
        </svg>
      ),
      points: [
        "Direct communication with customers",
        "Build trust and loyalty",
        "Viral effect - Automatically leads to New customers",
      ],
    },
    {
      title: "Go Digital in 24 Hours",
      description:
        "No long waiting periods - No painful registration process - Business goes digital within a day.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M13 10V3L4 14h7v7l9-11h-7z"
          />
        </svg>
      ),
      points: [
        "Quick setup and training",
        "Start selling immediately",
        "Excellent support",
      ],
    },

    {
      title: "Digital Documentation",
      description:
        "Anything you do on Paper, Notebook, Diary or Register can be digitized at the cost of Chai-Samosa.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          />
        </svg>
      ),
      points: [
        "Excellent Data Quality for Credibility",
        "Treacebility features inbuilt",
        "Time saving and Improved Productivity",
      ],
    },
    {
      title: "Data-Driven Decisions",
      description:
        "Unlock growth with data-driven decisions that help businesses thrive and stay ahead of the competition.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
      ),
      points: [
        "Empower Your Business with Data Insights for Smarter Growth",
        "Turn Data into Actionable Strategies for Business Success",
        "Become Digital - Grow Exponential",
      ],
    },
    {
      title: "Enterprise-Grade Data Security",
      description:
        "Data is protected with robust, encrypted systems built for trust and compliance.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-blue-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 3l8 4v5c0 5.25-3.75 9.75-8 11-4.25-1.25-8-5.75-8-11V7l8-4z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M9 12v2a3 3 0 006 0v-2a3 3 0 00-6 0z"
          />
        </svg>
      ),
      points: [
        "End-to-end encryption",
        "Regular backups & recovery",
        "Role-based access control",
      ],
    },
  ];
  const benefitsData = [
    {
      number: 1,
      title: "No Tech Skills Required",
      desc: "GeeQR solutions are very simple and perfect for less tech-savvy users, farmers, rural enpreprenuers and small business owners and makes their digital journey easy, simple and comfortable.",
    },
    {
      number: 2,
      title: "Affordable & Scalable",
      desc: "GeeQR solutions are poket friendly, inital investment is very low, pay nominal price later as you grow without breaking the bank.",
    },
    {
      number: 3,
      title: "Customizable Solutions",
      desc: "GeeQR standard solutions are very well designed, however, these solutions can be configured and customized as per the client's specific needs.",
    },
    {
      number: 4,
      title: "Simple Yet Powerful Tools",
      desc: "Simplicity is the ultimate sophistication. We truly live this phrase. GeeQR solutions are User-Friendly and help accomplish the business tasks very effectively and enhance productivity.",
    },
    {
      number: 5,
      title: "Boosts Local Economy",
      desc: "GeeQR solutions help serve current customers better and reach new customers easily. These solutions are truly the powerful engines to Expand your reach, enhance visibility, and support the local economy.",
    },
    {
      number: 6,
      title: "Real-Time Support",
      desc: "Get ongoing assistance for optimized operations and seamless business management.",
    },
  ];
  return (
    <section id="features" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Features
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Why choose GeeCom&apos;s QR-based digital platform? Discover the
            tools that make digital inclusion real for Bharat.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="relative mb-6 overflow-hidden rounded-lg bg-blue-50 h-48 flex items-center justify-center transition-all duration-300 group-hover:shadow-lg">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-100 to-blue-50 opacity-80"></div>
                <div className="relative z-10 text-center p-4">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-sm mb-4">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {feature.title}
                  </h3>
                </div>
              </div>
              <div>
                <p className="text-gray-600 mb-4">{feature.description}</p>
                <ul className="space-y-2">
                  {feature.points.map((point, idx) => (
                    <li key={idx} className="flex items-start">
                      <svg
                        className="h-5 w-5 text-blue-600 mr-2 flex-shrink-0 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-sm text-gray-700">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Feature Highlight with Image */}
        <div
          className="mt-24 bg-gray-50 rounded-2xl overflow-hidden"
          id="el-uzt0etx3"
        >
          <div className="flex flex-col md:flex-row" id="el-ddq3438d">
            <div
              className="w-full md:w-1/2 p-8 md:p-12 flex flex-col justify-center"
              id="el-f7wkob03"
              data-aos="fade-right"
            >
              <h3
                className="text-2xl font-bold text-gray-900 mb-4"
                id="el-ulb1ehm0"
              >
                Why People Choose GeeCom India
              </h3>
              <p className="text-gray-600 mb-8" id="el-ulb1ehm0">
                Our grassroots-first QR-based digital platform makes digital
                inclusion real for Bharat.
              </p>

              <div className="space-y-4" id="el-r822nboz">
                {benefitsData.map((item, index) => (
                  <div className="flex items-start" key={index}>
                    <div className="flex-shrink-0 h-6 w-6 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <span className="text-blue-600 text-sm font-medium">
                        {item.number}
                      </span>
                    </div>
                    <div>
                      <h4 className="text-base font-medium text-gray-900">
                        {item.title}
                      </h4>
                      <p className="text-sm text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href="#contact"
                className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors mt-8"
                target="_self"
                data-aos="fade-up"
              >
                Get started today
                <svg
                  className="ml-2 w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </a>
            </div>

            <div
              className="w-full md:w-1/2 flex items-center justify-center"
              data-aos="fade-left"
            >
              <img
                src={SirImage}
                alt="Sir's Photo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/800x600?text=GeeCom+Features";
                  e.target.classList.add("object-contain", "p-4");
                }}
                className="object-cover rounded-xl shadow-lg"
                style={{ width: "550px", height: "600px" }}
              />
            </div>
          </div>
        </div>

        {/* Modal Feature Showcase Button */}
        {/* <div className="mt-16 text-center">
          <button
            onClick={openModal}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
            Watch Feature Demo
          </button>
        </div> */}
      </div>

      {/* Feature Demo Modal */}
      {/* {isModalOpen && (
        <div
          id="feature-demo-modal"
          className="fixed inset-0 z-50 flex items-center justify-center"
          aria-modal="true"
          role="dialog"
        >
          Modal Background Overlay
          <div
            id="modal-overlay"
            className="absolute inset-0 bg-black bg-opacity-75 transition-opacity"
            onClick={closeModal}
          />
          Modal Content
          <div
            className="relative bg-white rounded-lg max-w-3xl w-full mx-4 overflow-hidden shadow-xl transform transition-all"
            role="dialog"
            aria-modal="true"
          >
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-gray-900">
                  GeeCom Features Demo
                </h3>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-gray-500 focus:outline-none"
                  aria-label="Close modal"
                >
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="aspect-w-16 aspect-h-9 bg-gray-100 rounded-lg flex items-center justify-center">
                Video placeholder
                <div className="text-center p-8">
                  <svg
                    className="w-16 h-16 text-blue-600 mx-auto mb-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p className="text-gray-600">
                    Feature demonstration video would appear here
                  </p>
                </div>
              </div>
              <div className="mt-6 space-y-4">
                <h4 className="font-medium text-gray-900">
                  Featured QR-based Solutions:
                </h4>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <li className="flex items-center">
                    <svg
                      className="h-5 w-5 text-blue-600 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-sm">Digital Shop Setup</span>
                  </li>
                  <li className="flex items-center">
                    <svg
                      className="h-5 w-5 text-blue-600 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-sm">Inventory Management</span>
                  </li>
                  <li className="flex items-center">
                    <svg
                      className="h-5 w-5 text-blue-600 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-sm">Survey & Form Collection</span>
                  </li>
                  <li className="flex items-center">
                    <svg
                      className="h-5 w-5 text-blue-600 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-sm">Organic Certification</span>
                  </li>
                </ul>
              </div>
              <div className="mt-6 text-center">
                <a
                  href="#contact"
                  onClick={() => {
                    setIsModalOpen(false); 
                  }}
                  className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium transition-colors duration-300"
                >
                  Request Full Demo
                </a>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </section>
  );
};

export default Features;
